export const safeGuidanceHeading = 'Get help now if you need it';

export const restartFromNhsAppGuidancePoints = [
  'Start again from the NHS App if you want to try this journey again.',
  'Call 111 if you need urgent medical help or advice.',
  'Call 999 if this is an emergency.',
] as const;

export const reconnectFromNhsAppGuidancePoints = [
  'Reconnect to the internet and try again from the NHS App if you want to continue this journey.',
  'Call 111 if you need urgent medical help or advice.',
  'Call 999 if this is an emergency.',
] as const;